import { FC, memo } from 'react';
import { Avatar as ChakraAvatar } from '@chakra-ui/react';

import { AvatarProps } from './types/AvatarProps';

const AvatarComponent: FC<AvatarProps> = ({
  fallback,
  src,
  badge = null,
  colorPalette = 'gray',
  ...props
}) => (
  <ChakraAvatar.Root
    colorPalette={colorPalette}
    size="md"
    variant="solid"
    {...props}
  >
    {src && <ChakraAvatar.Image alt={fallback} src={src} />}
    <ChakraAvatar.Fallback name={fallback} />
    {badge}
  </ChakraAvatar.Root>
);

export const Avatar = memo(AvatarComponent);
